export const removeBootsplash = () => {
  window.document.body.classList.add('u-app-initialized')
}
